// Structured mirror of the root CHANGELOG.md, used by the in-app Changelog modal
// (opened from the version number on the Login page and the Topbar).
// Keep new releases added to the TOP of this array, and mirror the same entry
// in CHANGELOG.md at the repo root.

const changelogData = [
  {
    version: "1.2.0",
    date: "2026-10-27",
    added: [
      "Quotation / Sale / VAT Sale: each item row now has a % / ฿ toggle on the discount field, so a discount can be entered as a percentage or as a flat amount (the equivalent percent is kept for saving and printing).",
      "Quotation Edit: the Edit button on Quotation History now opens the quotation with its customer, valid-until date and items filled in. New Update Quotation and Update and Print Quotation buttons replace Save while editing.",
    ],
    changed: [
      "Backend: quotation_items inserts now include discount_percent, and quotations / quotation_items are allowed in the delete route. Run add_quotation_item_discount.sql on the database before deploying.",
    ],
    fixed: [
      "Quotation History / Quotation print: the item Disc% column was hardcoded to 0% — the discount percent is now saved with each item and printed.",
      "Quotation History print: item descriptions were blank.",
      "Quotation History delete: it called routes that do not exist; it now uses /deletebyid.",
    ],
  },
  {
    version: "1.1.9",
    date: "2026-10-03",
    added: [
      "Bill History: select bills with checkboxes (or Select all) and Print Selected (one window, one invoice per A4 page) or Download Selected PDF (all selected invoices in one PDF file).",
      "Bill History: new designed Summary PDF with KPI cards, striped table and an analytics page (monthly sales bar chart, daily trend line, payment-mode donut and summary strip); PDF order option Oldest first (ASC) / Newest first (DESC).",
      "Bill History: sortable table columns (Inv. No., Inv Date, Setup Date, Subtotal, Tax, Grand Total).",
      "Stock Report / Purchase Report: new Purchase Details view (stock-in records only) with detail table, summary cards, Monthly Purchase Summary chart, Top Suppliers chart, row selection with Print Selected / Download Selected PDF, and a designed Purchase Summary PDF with ASC/DESC order option.",
    ],
    changed: [
      "Bill History: monthly sales chart now sorts months chronologically, shows bills count line, value labels and ฿ tooltips, follows the active filters/tab and no longer crashes on bills without a date.",
      "Bill History: single-bill print now uses the shared invoice template (billInvoiceTemplate.js) also used by bulk print/PDF; added html2canvas as an explicit dependency.",
    ],
    fixed: [],
  },
  {
    version: "1.1.8",
    date: "2026-08-22",
    added: [],
    changed: [
      "itemWiseSummaryVat report: Start/End Date pickers replaced with a single Date Range picker; Item Name filter is now an autocomplete dropdown suggesting matching item names as you type.",
      "itemWiseSummaryVat report: removed the Table Category Summary view (Category Summary and Subcategory Summary remain).",
      "itemWiseSummaryVat report: added a bar chart at the bottom of the page (Total & VAT, top 10 by amount) reflecting the currently active view.",
    ],
    fixed: [
      "itemWiseSummaryVat report: date range filter returned 0 records — dates were sent to the API in DD-MM-YYYY format (incompatible with SQL BETWEEN) and the backend filtered on final_bill.inv_date instead of order_items.setup_date. Both fixed.",
      "itemWiseSummaryVat report: VAT % and VAT Amount were hardcoded to 7% for every row regardless of the actual order_items.vat value (0% VAT items still showed 7%) — now uses the real per-item VAT from the database.",
    ],
  },
  {
    version: "1.1.7",
    date: "2026-08-08",
    added: [
      "Payment Voucher: new \"Discount Received from Supplier\" option, mirroring the Receipt Voucher discount flow — reduces the outstanding balance owed with no cash/bank outflow, shown on the printed voucher, Excel/PDF exports and the payment history table.",
    ],
    changed: [],
    fixed: [
      "Sale page (sale.js): the printed invoice's item Discount% column was hidden unless \"Show VAT Details\" was enabled — it's now always shown.",
      "Sale page (sale.js): the overall Discount amount on the printed invoice always showed ฿0.00 because it read an unused/unset form field instead of the actual sum of item-level discounts — it now shows the correct total, for Save, Save & Print and Edit Bill.",
      "GST bills: per-item discount % was never saved to the database (order_items_gst had no column for it), so it could never appear on a reprint — the column now exists and is saved.",
    ],
  },
  {
    version: "1.1.6",
    date: "2026-08-08",
    added: [
      "Receipt Voucher: new \"Give Discount to Customer\" option — waives off part of the outstanding balance (no cash/bank inflow), with its own summary block, and is included on the printed receipt, Excel/PDF exports and the payment history table.",
      "Left sidebar: Logout button added at the bottom of the menu.",
      "App version number is now shown on the Login page and in the top bar; clicking it opens this Changelog.",
    ],
    changed: [],
    fixed: [],
  },
  {
    version: "1.1.5",
    date: "2026-06-23",
    added: [
      "Barcode Label Printer (New Item page): print layout option to choose 1-4 label columns based on thermal paper width, with five label-size presets (30x20, 40x30, 50x25, 58x40, 100x50mm). Prices now display in Baht (฿).",
      "Bill History page: \"Cancel\" action on each bill row (with confirmation), which marks the bill as cancelled and removes its associated ledger entries.",
      "Customer Ledger (saleLedger): \"Adjust\" action on each ledger row to correct a Debit or Credit amount directly, with a confirmation modal.",
    ],
    changed: [
      "itemWiseSummaryVat report: redesigned with Ant Design (colorful cards, table, filters).",
      "quotationHistory page: redesigned with Ant Design (status tags, item-detail view modal, icon actions).",
      "quotation page: redesigned to visually match the Sale page layout/style; all existing functionality preserved.",
    ],
    fixed: [
      "Receipt/Payment Voucher creation: ledger entries now save the date submitted from the form instead of the current date.",
      "New Stock page: disabling \"Credit to Supplier Ledger\" no longer saves an entry to the supplier ledger.",
      "itemWiseSummaryVat: Item Code column no longer shows \"N/A\" (now joined from the items table).",
      "quotation page: line-item rate now saves correctly to quotation_items (was saving as 0).",
      "quotationHistory view modal: Unit Price/Amount now display correctly instead of ฿0.00.",
      "Customer Ledger (saleLedger): running Balance column no longer shows scrambled/non-monotonic values across pages (cumulative balance is now computed once over the full filtered dataset instead of per-page).",
      "Bill History page: bills with no setup_date (e.g. #35, #36) no longer disappear from the list when a date filter or date sort is applied (now falls back to inv_date); removed silently-persisted localStorage date filters that re-applied across sessions.",
      "Cancel Bill flow: fixed a broken ledger-cleanup request so cancelling a bill correctly removes its ledger entries.",
    ],
  },
];

export default changelogData;
